import cn from 'classnames';
import useLocalStudioRecentlyViewed from 'hooks/useLocalStudioRecentlyViewed';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { GettyImagesImageSearchResponseImage } from 'store/studioSearch/types';
import relativeLink from 'utils/routes/relativeLink';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmGettySearchClickEvent from 'utils/gtm/gtmGettySearchClickEvent';
import { useSelector } from 'react-redux';
import getStudioSearchQuery from 'store/studioSearch/selector/getStudioSearchQuery';
import styles from './SearchResultsGallery.module.scss';

export interface Props {
  className?: string;
  items: GettyImagesImageSearchResponseImage[];
  isLoading: boolean;
  shouldStoreRecent?: boolean;
}

const SearchResultsGallery = ({ className, items, shouldStoreRecent = true }: Props) => {
  const location = useLocation();
  const { storeRecentlyViewed } = useLocalStudioRecentlyViewed();
  const query = useSelector(getStudioSearchQuery);

  const handleClick = (item: GettyImagesImageSearchResponseImage) => () => {
    gtmSendEvent(gtmGettySearchClickEvent(item.name, query));
    shouldStoreRecent && storeRecentlyViewed(item);
  };

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.list}>
        {items.map((item) => (
          <Link
            key={item.id}
            className={styles.item}
            to={relativeLink(item.productPageUrl, { from: location.pathname + location.search })}
            onClick={handleClick(item)}
          >
            <img className={styles.image} src={item.displaySizes[1].uri} loading="lazy" alt={item.title} />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SearchResultsGallery;
